import styled from 'styled-components'

export const StatusBadge = styled.span<{ state: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  background-color: ${({ state }) => {
    switch (state.toLowerCase()) {
      case 'success':
        return '#d4edda'
      case 'error':
      case 'errored':
        return '#f8d7da'
      case 'pending':
      case 'waiting':
        return '#fff3cd'
      case 'running':
      case 'started':
        return '#cce5ff'
      default:
        return '#e2e3e5'
    }
  }};
  color: ${({ state }) => {
    switch (state.toLowerCase()) {
      case 'success':
        return '#155724'
      case 'error':
      case 'errored':
        return '#721c24'
      case 'pending':
      case 'waiting':
        return '#856404'
      case 'running':
      case 'started':
        return '#004085'
      default:
        return '#383d41'
    }
  }};
`
